// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ApiWrapper__wrapper___3cMVZ","back":"ApiWrapper__back___XDEOv","backArrow":"ApiWrapper__backArrow___1_H-6","backText":"ApiWrapper__backText___3Q5uE"};